import {setPageConfig,setNowTabPageCongfig,clearRowDataDeep,getMyColums} from "@/tools/table-drag.js";
let cacheSize = parseInt(localStorage.getItem('pageSize'));
import {getRandomString,isNotEmpty} from "@/tools/utils";
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';;
const tableData = {};
const pageConfig = {
    resetPage:null,
    loading:false,
    tableName:'material-data',
    height:'',
    pageKey:getRandomString(),
    top_tools:{
        "HEADER":[
            // { index: 1, name: ['手动推送'], icon: 'fas fa-paper-plane', check_lines: 0, on_click: [], sign: 'sendOrder', },
            // { index: 0, name: ['手动更新物料'], icon: 'fas fa-sync-alt', check_lines: 0, on_click: [], sign: 'updateErpMaterial', },
            { index: 0, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            // { index: 1, name: ['手动接收'], icon: 'fas fa-hand-paper', check_lines: 0, on_click: [], sign: 'handleGet', },
        ]
    },
    pageConfig:{},
    pageConfigTree:[],
    dialogPage:{
        colseDialogFun:null,
        isPushIng:false,
        isFalsePagination:['DATA'],
        resetPage:null,
        loading:false,
        tableName:'material-data-send-Dialog',
        height:'',
        pageKey:getRandomString(),
        getPageKey:'inventoryInformation/getPushDataPageKey',
        top_tools:{},
        pageConfig:{},
        pageConfigTree:[],
        msgArr:[],
        completed:{},
    }
}
const state = () => ({
    inventoryInformation: Object.assign({}, tableData,pageConfig),
})
const getters = {
    getPageConfig: state => state.inventoryInformation.pageConfig,
    getPageConfigTree: state => state.inventoryInformation.pageConfigTree,
    getPageKey:state => state.inventoryInformation.pageKey,
    getPushDataDialog:state => state.inventoryInformation.dialogPage,
    getPushDataPageKey:state => state.inventoryInformation.dialogPage.pageKey,
    getPushMsg:state => state.inventoryInformation.dialogPage.msgArr,
    geCompleted:state => state.inventoryInformation.dialogPage.completed,
}
const mutations ={
    setRestPageFun(state, data){
        state.inventoryInformation.resetPage = data;
    },
    setLoading(state, data){
        state.inventoryInformation.loading = data;
        if(isNotEmpty(state.inventoryInformation.pageConfig)){
            Object.keys(state.inventoryInformation.pageConfig).forEach((key,index)=>{
                state.inventoryInformation.pageConfig[key].loading = data;
            })
        }
    },
    setPageConfig(state, data){
        state.inventoryInformation.pageConfig = data.pageConfig;
        state.inventoryInformation.pageConfigTree = data.allArrData;
        state.inventoryInformation.pageKey = getRandomString();
        if(isNotEmpty(state.inventoryInformation.pageConfig)){
            Object.keys(state.inventoryInformation.pageConfig).forEach((key,index)=>{
                state.inventoryInformation.pageConfig[key].height = state.inventoryInformation.height
            })
        }
    },
    setPushDialogConfig(state, data){
        state.inventoryInformation.dialogPage.pageConfig = data.pageConfig;
        state.inventoryInformation.dialogPage.pageConfigTree = data.allArrData;
        state.inventoryInformation.dialogPage.pageKey = getRandomString();
        if(isNotEmpty(state.inventoryInformation.dialogPage.pageConfig)){
            Object.keys(state.inventoryInformation.dialogPage.pageConfig).forEach((key,index)=>{
                state.inventoryInformation.dialogPage.pageConfig[key].height = state.inventoryInformation.height
            })
        }
    },
    setPushDialogList(state, data){
        state.inventoryInformation.dialogPage.pageConfig[data.obj].data = data.data;
        state.inventoryInformation.dialogPage.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    setList(state, data) {
        state.inventoryInformation.pageConfig[data.obj].data = data.data;
        state.inventoryInformation.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    ['refreshTableHeight'](state, data) {
        state.inventoryInformation.height = (data-50) + 'px';
        if(isNotEmpty(state.inventoryInformation.pageConfig)){
            Object.keys(state.inventoryInformation.pageConfig).forEach((key,index)=>{
                state.inventoryInformation.pageConfig[key].height = state.inventoryInformation.height;
            })
        }
        state.inventoryInformation.dialogPage.height = (data-50) + 'px';
        if(isNotEmpty(state.inventoryInformation.dialogPage.pageConfig)){
            Object.keys(state.inventoryInformation.dialogPage.pageConfig).forEach((key,index)=>{
                state.inventoryInformation.dialogPage.pageConfig[key].height = state.inventoryInformation.height
            })
        }
    },
    ['clearData'](state, data) {
        clearRowDataDeep({tabName:data.tabName,pageConfig:state.inventoryInformation.pageConfig,pageConfigTree:state.inventoryInformation.pageConfigTree});
    },
    ['clear-push-msg'](state, data) {
        state.inventoryInformation.dialogPage.isPushIng = false;
        state.inventoryInformation.dialogPage.msgArr=[];
        state.inventoryInformation.dialogPage.completed={};
    },
}
const actions = {
    ['handlePushData']({ state, dispatch, rootState ,commit}, payload) {
        state.inventoryInformation.dialogPage.colseDialogFun = payload.colseDialogFun;
        if(state.inventoryInformation.dialogPage.isPushIng){
            dispatch('response/negative', { message: '推送数据处理中，请误重复操作！' }, { root: true })
            return
        }
        state.inventoryInformation.dialogPage.isPushIng = true;
        let msg = { command: "post_client__inventory_push",message: {},to: "client",'is_not_net_request':true}
        dispatch('response/info-tip', { message: '推送开始请耐心等待。。。' }, { root: true })
        dispatch('channel/socket_send', msg, { root: true })
    },
    ['pushDataReturn']({ state, commit,dispatch }, payload) {
        // state.inventoryInformation.dialogPage.isPushIng = false;
        // state?.inventoryInformation?.dialogPage?.colseDialogFun();
        state.inventoryInformation.dialogPage.completed.data = 1;
        if (payload.success) {
            dispatch('response/success-tip', { message: '推送成功' }, { root: true })
            state?.inventoryInformation?.resetPage({});
        }
    },
    async ['fetch-push-data-list']({ state, dispatch, rootState ,commit}, payload) {
        state.inventoryInformation.dialogPage.pageConfig = {};
        state.inventoryInformation.dialogPage.pageConfigTree = [];
        let msg = { command: "post_client__inventory_push_data",message: {},to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async['return_list-push-data']({ state, commit }, payload) {
        if (payload.success) {
            let pageData = setPageConfig({
                pageData:payload.data.objs,
                tableName:state.inventoryInformation.dialogPage.tableName,
                top_tools:state.inventoryInformation.dialogPage.top_tools,
                isFalsePagination:state.inventoryInformation.dialogPage.isFalsePagination
            });
            commit('setPushDialogConfig',pageData);
            let myCoums = await getMyColums({name:state.inventoryInformation.dialogPage.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.inventoryInformation.dialogPage.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            commit('setPushDialogList',payload.data);
        }
    },
    async ['fetch-list']({ state, dispatch, rootState ,commit}, payload) {
        if(state.inventoryInformation.loading) return;
        commit('setLoading',true);
        let msg = { command: "get_client__inventory_history", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['return_list']({ state, commit }, payload) {
        commit('setLoading',false);
        if (payload.success) {
            if(!isNotEmpty(state.inventoryInformation.pageConfigTree)){//生成 页面列配置 并处理成需要的结构
                let pageData = setPageConfig({pageData:payload.data.objs,tableName:state.inventoryInformation.tableName,top_tools:state.inventoryInformation.top_tools});
                commit('setPageConfig',pageData);
            }
            let myCoums = await getMyColums({name:state.inventoryInformation.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.inventoryInformation.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            commit('setList',payload.data);
        }
    },
    ['push_pushing_msg']({ state, commit }, payload) {
        state.inventoryInformation.dialogPage.msgArr.unshift(payload);
        state.inventoryInformation.dialogPage.msgArr.sort((a, b) => b.timestamp - a.timestamp);
    },
    ['set_pushing_completed']({ state, commit }, payload) {
        if(isNotEmpty(state.inventoryInformation.dialogPage.completed) && state.inventoryInformation.dialogPage.completed.time > payload.time){
            return
        }
        Object.keys(payload).forEach(key=>{
            state.inventoryInformation.dialogPage.completed[key] = payload[key];
        })
    },
    ['return_export']({ state, commit }, payload) {
        if(payload.success){
            window.open(process.env.VUE_APP_APIHOST+'/'+payload.data);
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        let msg = { command: "get_client__inventory_export_excel", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_inventory__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
